export default __webpack_public_path__ + "static/media/Montserrat_Medium.449fdb74.woff2";